import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["allProjects", "projectList"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasAllProjectsTarget || !this.hasProjectListTarget) return

    const all = this.allProjectsTarget.checked
    this.projectListTarget.classList.toggle("opacity-50", all)
    this.projectListTarget.querySelectorAll("input[type=checkbox]").forEach((input) => {
      input.disabled = all
    })
  }
}
